import { useState, useEffect } from "react";
import {
  getTaskFilterState,
  saveTaskFilterState,
  resetTaskFilterState
} from "@/services/common/db/owner/showTaskFilters";

type FilterListState = {
  targetMonth: boolean;
  status: boolean;
  workFrequency: boolean;
  problem: boolean;
  crew: boolean;
  jobCategory: boolean;
};

function useFilterList() {
  const [showFilterList, setShowFilterList] = useState<FilterListState>({
    targetMonth: true,
    status: true,
    workFrequency: true,
    problem: true,
    crew: false,
    jobCategory: false
  });

  // IndexedDBから表示状態を取得
  useEffect(() => {
    const loadFilterState = async () => {
      const savedState = await getTaskFilterState();
      if (savedState) {
        setShowFilterList(savedState);
      } else {
        await resetTaskFilterState();
        // リセット後の状態を再取得して設定
        const initialState = await getTaskFilterState();
        if (initialState) {
          setShowFilterList(initialState);
        }
      }
    };
    loadFilterState();
  }, []);

  // 表示状態が変更されたらIndexedDBに保存
  useEffect(() => {
    const saveState = async () => {
      // 初期レンダリング時は保存をスキップ
      if (
        JSON.stringify(showFilterList) ===
        JSON.stringify({
          targetMonth: true,
          status: true,
          workFrequency: true,
          problem: true,
          crew: false,
          jobCategory: false
        })
      ) {
        return;
      }
      await saveTaskFilterState(showFilterList);
    };
    saveState();
  }, [showFilterList]);

  return { showFilterList, setShowFilterList };
}

export default useFilterList;
